<template>
  <div class="w-full">
    <div class="w-full text-center" v-if="loading">
      <div class="py-5" colspan="4">
        <h1 class="text-2xl">
          <i class="fa fa-circle-notch fa-spin text-white"></i>
        </h1>
      </div>
    </div>

    <!-- chasers -->
    <div class="flex flex-wrap">
      <router-link
        class="bg-white overflow-hidden shadow rounded-lg w-full mb-4 hover:bg-gray-50 group flex flex-row px-4 py-5 sm:px-6 "
        v-for="announcement in announcements"
        v-bind:key="announcement.id"
        :to="{
          name: 'StringerAnnouncementView',
          params: { uuid: announcement.id }
        }"
      >
        <div class="flex flex-row space-x-4 items-center flex-1">
          <AccountIcon
            :initials="announcement.sender.name | initials(' ')"
            :size="10"
          />
          <div class="flex flex-col flex-1">
            <h1 class="text-lg font-medium">{{ announcement.title }}</h1>
            <span
              class="text-sm text-gray-600"
              :title="announcement.created_at | displayLocalDateTime"
              v-tippy
              >{{ announcement.created_at | timeAgo }}</span
            >
          </div>
          <div class="space-x-2">
            <p
              class="px-2 inline-flex items-center text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800 space-x-1"
            >
              <i class="fas fa-comment text-gray-500"></i>
              <span>{{ announcement.commentsCount }}</span>
            </p>
            <p
              class="px-2 inline-flex  items-center text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800 space-x-1"
            >
              <i class="fas fa-user text-gray-500"></i>
              <span>{{ announcement.viewsCount }}</span>
            </p>
          </div>
        </div>
        <div
          class="flex items-center justify-center opacity-0 transition-all group-hover:opacity-100 ml-2"
        >
          <i class="fa fa-chevron-right mt-1"></i>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";
import AccountIcon from "@/components/AccountIcon";

export default {
  name: "Announcements",
  components: { AccountIcon },
  data() {
    return {
      announcements: [],
      loading: true
    };
  },
  mounted() {
    this.getAnnouncements();
  },
  methods: {
    getAnnouncements() {
      this.$http
        .get(Config.apiPath + "/api/v2/stringer/announcements")
        .then(response => {
          this.$set(this, "announcements", response.data);
          this.$set(this, "loading", false);
        });
    }
  }
};
</script>

<style scoped>
.user-panel {
  background-color: #f6f7f8;
}
</style>
